// Bread data
const breads = [
  {
    id: 1,
    name: 'Rye',
    label: 'Rye (Default)',
    price_adjustment: 0.00
  },
  {
    id: 2,
    name: 'Wheat',
    label: 'Wheat',
    price_adjustment: 0.00
  },
  {
    id: 3,
    name: 'Texas Toast',
    label: 'Texas Toast',
    price_adjustment: 0.00
  },
  {
    id: 4,
    name: 'Kaiser Roll',
    label: 'Kaiser Roll',
    price_adjustment: 1.50
  },
  {
    id: 5,
    name: 'Onion Roll',
    label: 'Onion Roll',
    price_adjustment: 1.50
  },
  {
    id: 6,
    name: 'Bagel',
    label: 'Bagel',
    price_adjustment: 0.00
  },
  {
    id: 7,
    name: 'Lettuce Wrap',
    label: 'Lettuce Wrap',
    price_adjustment: 2.00
  },
  {
    id: 8,
    name: 'No Bread',
    label: 'No Bread',
    price_adjustment: 0.00
  },
  {
    id: 9,
    name: 'Hot Dog Bun',
    label: 'Hot Dog Bun',
    price_adjustment: 0.00
  },
  {
    id: 10,
    name: 'Challah',
    label: 'Challah',
    price_adjustment: 1.50
  }
];

export default breads;